import { Product, ProductFormatted } from '@/types/product'
import Image from 'next/image'
import Link from 'next/link'

// Helper to normalize product data
const normalizeProduct = (
  product: Product | ProductFormatted
): ProductFormatted => {
  if ('href' in product) {
    // It's already a ProductFormatted
    return product
  }
  // It's a Product, so we need to format it
  return {
    id: product._id,
    href: `/product/${product.seo_alias}`,
    title: product.title,
    regular_price: product.regular_price,
    compare_price: product.compare_price,
    note: product.addon_note_collection,
    is_combo: product.is_combo,
    sale_percent: product.percent,
    active: product.available,
    default_thumbnail: product.images?.[0]?.src || '',
    default_thumbnail_hover:
      product.images?.[1]?.src || product.images?.[0]?.src || '',
    tags: Object.values(product.tags),
    is_free_shipping: false, // This info might not be available on the base Product type
    is_quick_add: false, // This info might not be available on the base Product type
    mapped_variants: {}, // This would require significant logic to build
  }
}

interface ProductGridProps {
  title?: string
  products: (Product | ProductFormatted)[]
}

export function ProductGrid({ title, products }: ProductGridProps) {
  console.log('🧙 ~ ProductGrid ~ products:', products)
  if (!products || products.length === 0) {
    return null
  }

  const formattedProducts = products.map(normalizeProduct)

  return (
    <div className='my-8'>
      {title && <h2 className='mb-4 text-2xl font-bold'>{title}</h2>}
      <div className='grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4'>
        {formattedProducts.map((product) => (
          <Link
            href={product.href}
            key={product.id}
            className='group block overflow-hidden rounded-lg border'
          >
            <div className='relative aspect-[3/4] overflow-hidden'>
              <Image
                src={product.default_thumbnail || '/images/placeholder.png'}
                alt={product.title}
                fill
                className='object-cover transition-transform duration-300 group-hover:scale-105'
              />
            </div>
            <div className='p-2'>
              <h3 className='truncate font-semibold'>{product.title}</h3>
              <p className='text-sm text-gray-500'>
                {product.regular_price.toLocaleString('vi-VN')}₫
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  )
}
